import { Component, computed, input } from '@angular/core';

import { CmsContent } from '@fcom/core-api';

@Component({
  selector: 'fin-informational-teaser',
  templateUrl: './informational-teaser.component.html',
  styleUrls: ['./informational-teaser.component.scss'],
  standalone: false,
})
export class InformationalTeaserComponent {
  informationalTeaser = input<CmsContent>();

  isSingleImage = computed(() => {
    return this.informationalTeaser().items.length === 1;
  });
}
